import { render, staticRenderFns } from "./AdminDashboardPage.vue?vue&type=template&id=54712f84"
import script from "./AdminDashboardPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminDashboardPage.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports